import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { PendoService } from 'src/app/services/pendo/pendo.service';
import { ScopeSequenceTabs, ScopeSequenceTab } from '../../models/scope-sequence-tab.model';
import { FeatureToggleService } from 'src/app/services/feature-toggle/feature-toggle.service';

@Component({
  selector: 'app-scope-sequence-tabs',
  templateUrl: './scope-sequence-tabs.component.html',
  styleUrls: ['./scope-sequence-tabs.component.scss']
})
export class ScopeSequenceTabsComponent implements OnInit {
  @Output() public tabChanged = new EventEmitter<ScopeSequenceTabs>();

  public tabs: ScopeSequenceTab[] = [
    {
      id: ScopeSequenceTabs.Core,
      isAvailable: true,
      displayName: 'Core Concepts'
    },
    {
      id: ScopeSequenceTabs.Prerequisite,
      isAvailable: false,
      displayName: 'Prerequisite Skills Plan'
    },
    {
      id: ScopeSequenceTabs.Enrichment,
      isAvailable: false,
      displayName: 'Enrichment Pathway'
    }
  ];

  private activeTab: ScopeSequenceTab = this.tabs[0];

  constructor(
    private pendoService: PendoService,
    private featureToggleService: FeatureToggleService
  ) { }

  public async ngOnInit(): Promise<void> {
    let enableTabs = await this.featureToggleService.isTrueAsync('enable-prerequisite-enrichment-pathways');

    if(!enableTabs) {
      return;
    }

    this.tabs[1].isAvailable = true;
    this.tabs[2].isAvailable = true;
  }

  public changeTab(tab: ScopeSequenceTab) {
    this.activeTab = tab;
    this.tabChanged.emit(tab.id);

    this.pendoService.sendEvent('ScopeSequenceTabClicked', tab.displayName);
  }

  public isActive(tab: ScopeSequenceTab): boolean {
    return tab.id === this.activeTab.id;
  }
}
